<template lang="html">
  <div class="shopify-create-store">
    <Guide
      :content="content"
      :contentVideo="contentVideo"
      contentHeading="Access Google Analytics"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="closeLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'AnalyticsAccess',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'analytics-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'analytics-admin',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
         <p>Go to your <a href="https://analytics.google.com/analytics/web/" target="_blank" class="btn is-tertiary">Google Analytics</a> dashboard.</p>

         <p>You may need to sign in to your Google account if you haven't already done so.</p>
        `
    },

    contentVideo() {
      return 'https://cdn.shopify.com/assets2/home/manage-animation-a9cecf49c4414fd02d9fa00482fd30e436fc373208255d90d92491be650b8d13.mp4'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
